var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolwp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21759B",
    d: "M24,48C10.7,48-0.1,37.4,0,24C0.101,10.6,10.2,0,24,0c13.801,0,24,10.8,24,24C48,37.199,37.3,48,24,48z  M31.1,44.299L24.3,26l-6.4,18.699C22.601,45.801,25.8,46.1,31.1,44.299L31.1,44.299z M14.5,43.301l-10.2-27.9 c-1.4,3-1.7,5.5-1.9,8.6C2.501,32.199,7.1,39.699,14.5,43.301z M45.5,24c0.1-5.3-2.3-9.5-2.5-10.1c0.2,4.101-0.4,6.199-1.1,8.5 l-7,20.099C43.7,37.199,45.398,29.301,45.6,24H45.5L45.5,24z M23.301,23.1l-3.4-9.3l-2.5-0.2c-1-0.7-0.4-1.8,0.3-1.8 c4.5,0.3,7,0.3,11.5,0c1.101,0,1.399,1.601,0.1,1.8l-2.4,0.2l7.799,22.999L38.397,24.2c0.201-5.499-1.3-6.099-3.3-10.099 C33.497,11,35.198,8,38.299,7.9c-2.502-2.4-7.601-5.4-14.301-5.5c-6.7-0.1-13.8,3.3-18,9.7l7.4-0.2c0.9,0.401,0.5,1.7,0,1.801 l-2.6,0.2l7.8,23.4L23.301,23.1L23.301,23.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolwp);
export default __webpack_public_path__ + "static/media/toolwp.e4cb32d76d9da689a1d8f8b50b8d156c.svg";
export { ForwardRef as ReactComponent };